import { Directive, Input, ElementRef } from '@angular/core';
export class TabToggleDirective {
   tabComponent;
/**
 * \@method constructor
 * @param {?} elementRef
 */
constructor(
public elementRef: ElementRef
  ) {}
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mkTabToggle]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'tabComponent': [{ type: Input, args: ['mkTabToggle', ] },],
};
}

function TabToggleDirective_tsickle_Closure_declarations() {
/** @type {?} */
TabToggleDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TabToggleDirective.ctorParameters;
/** @type {?} */
TabToggleDirective.propDecorators;
/** @type {?} */
TabToggleDirective.prototype.tabComponent;
/** @type {?} */
TabToggleDirective.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
